<template>
  <div class="machine">
    <div class="shop_top">
      <shop-top :subnav_show="false" :change_color="true"></shop-top>
    </div>
    <div class="width_center_1200">
      <div class="card-type">
        <el-tabs v-model="tabsData.current" @tab-click="handleTab">
          <el-tab-pane v-for="(item, index) in tabsData.list" :key="index" :label="item.name"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="width_center_1200">
      <div class="cards">
        <div v-for="(item, index) in list" :key="index" class="cards__item" @click.stop="$router.push(`/card/info/${item.id}`)">
          <div class="cards__pic">
            <el-image :src="item.homeimg" />
          </div>
          <div class="cards__bd flex-space-b">
            <div class="cards__cont">
              <div class="cards__name">{{ item.name }}</div>
              <div class="cards__price flex-align">
                <div class="cards__price--d">{{ unit }}<span>{{ item.price }}</span></div>
                <!-- <div class="cards__price--o">{{ unit }}{{ item.marketprice }}</div> -->
              </div>
            </div>
            <div class="cards__btn">{{ $t('goods_info').buy }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_fy_block width_center_1200">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next,jumper,total"
        :total="total"
        :page-size="listParams.pageSize"
        :current-page="listParams.pageNum"
      ></el-pagination>
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import { getCardTypeList, getCardList } from '@/api/card'
export default {
  components: {
    ShopTop,
    ShopFoot
  },
  data() {
    return {
      tabsData: {
        list: [],
        current: 0
      },
      loading: false,
      total: 0,
      list: [],
      listParams: {
        xm_monthlycardtypeid: '',
        pageNum: 1,
        pageSize: 20
      }
    }
  },
  computed: {
    lang() {
      return this.$t('machine')
    },
    ...mapGetters(['isLogin', 'location', 'unit'])
  },
  watch: {
    location: {
      handler(val) {
        if (val) {
          this.getType()
          this.getList()
        }
      },
      immediate: true
    }
  },
  methods: {
    async getType() {
      const { data } = await getCardTypeList()
      data.unshift({
        id: '',
        name: this.$t('machine').all
      })
      this.tabsData.list = data
    },
    handleTab(e) {
      this.listParams.xm_monthlycardtypeid = this.tabsData.list[Number(e.index)].id
      this.getList()
    },
    async getList() {
      this.loading = true
      try {
        const { data } = await getCardList(this.listParams)
        this.list = data.result
        this.total = data.totalNum
      } catch {
        this.loading = false
      }
    },
    changePage(val) {
      this.listParams.pageNum = val
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
  .card-type {
    position: relative;
    background: #fff;
    margin: 20px auto;
    /deep/ .el-tabs {
      &__header {
        margin: 0;
      }
      &__nav-scroll {
        padding: 0 20px;
      }
      &__nav-wrap::after {
        display: none;
      }
      &__item.is-active {
        color: #ec9221;
      }
      &__active-bar {
        color: #ec9221;
      }
      &__item:hover {
        color: #ec9221;
      }
      &__item {
        height: 52px;
        line-height: 52px;
        color: #aaaaaa;
        font-size: 14px;
      }
      &__active-bar {
        bottom: 10px;
      }
    }
  }
  .cards {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
    &__item {
      width: 392px;
      border-radius: 12px;
      margin-right: 12px;
      background-color: #fff;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
    &__pic {
      width: 392px;
      height: 172px;
      /deep/ img {
        border-radius: 12px 12px 0 0;
      }
    }
    &__bd {
      padding: 16px 10px 10px;
    }
    &__name {
			color: #000;
			font-size: 16px;
			margin-bottom: 4px;
		}
		&__price {
			&--d {
				color: #F24D45;
				font-size: 14px;
				span {
					font-size: 18px;
					font-weight: bold;
					padding-left: 2px;
				}
			}
			&--o {
				color: #909193;
				font-size: 14px;
				text-decoration: line-through;
				margin-left: 10px;
			}
		}
		&__btn {
			text-align: center;
			min-width: 104px;
			background-color: #EC9221;
			color: #fff;
			font-size: 14px;
			font-weight: 500;
			line-height: 32px;
			height: 32px;
			border-radius: 16px;
			padding: 0 10px;
			box-sizing: border-box;
		}
  }
</style>